export const urlsToHideForLanding = ['/a/v3', '/a/retouche-reparation/', '/a/reparation/', '/service-colis/'];
